import { useEffect, useState } from 'react';
import GuestNavlist from '../../components/GuestNavList';
import ReviewItem from '../../components/ReviewItem';
import '../../styles/styles.css';
import { useAxios } from '../../utils/hook/useAxios';
import { useUser } from '../../utils/hook/UserContext';

// MessageBox component
function GuestReviewsPage() {
  const [Reviews, setReviews] = useState([]);

  const { user, loading, isAuthenticated } = useUser();

  const [inviteId] = useState(user?.id);

  const axios = useAxios();
  useEffect(() => {
    localStorage.setItem('mode', 'guest');
  }, []);
  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get('/reviews/getbyUserId/' + inviteId);
        if (response.data) {
          const sortedData = response.data.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
          setReviews(sortedData);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  return (
    <section className="mb-3">
      <div className="container">
        <div className="row">
          <h1 className="mb-3">Liste de tous mes avis</h1>

          <div className="col-md-3 mb-3 d-none d-sm-block">
            <GuestNavlist></GuestNavlist>
          </div>

          <div className="col-md-8 mb-3">
            {Reviews &&
              Reviews.map((conv) => (
                <ReviewItem annuler={true} data={conv} key={conv.id}></ReviewItem>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default GuestReviewsPage;
